import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import SensorReadList from './index';

/**
 * ContinuousScanWrapper is used as MultiPickerTransactionGrid's SelectedRecordList. It used to be
 * rendered only from that grid's `!isContinuousScanEnabled` branch - i.e. specifically when the
 * grid had already decided continuous scan should NOT be active for this screen (wrong
 * hNode.title, tenant setting off, or non-native). That guard is gone: the grid now renders this
 * unconditionally so manual/barcode entries survive the round-trip to Screen B and back. Reader
 * reads are kept out of it at the source instead, by the sensor:read remove in the grid itself
 * (#1808) - not here. This wrapper used to duplicate the enablement decision with its own
 * title-unaware continuousScanSettings check and swap in ContinuousScanTestUtils'
 * MockContinuousScanScreen - dev/test scaffolding, never real scanning - whenever the tenant
 * setting was on, regardless of which screen was rendering it (e.g. Check In/Check Out, which are
 * out of continuous scan's PRD scope per docs/product/prds/continuous-scan/continuous-scan.md §3).
 * Real continuous scan is handled entirely by the parent grid's own handleOpenContinuousScan/
 * ContinuousScanPage flow, so this always renders the plain list.
 */
export default function ContinuousScanWrapper(props) {
  // eslint-disable-next-line no-unused-vars
  const { onClose, onFinish, ...sensorListProps } = props;
  return rc(SensorReadList, sensorListProps);
}

ContinuousScanWrapper.propTypes = {
  ...SensorReadList.propTypes,
  onClose: PropTypes.func,
  onFinish: PropTypes.func
};
